import { IDropdownOption } from 'office-ui-fabric-react';
import { ILocationItem } from '../components/custom/LocationTree';

const mapLocationsToOptions = (locations: ILocationItem[] | null, withEmptyChoice: boolean): IDropdownOption[] => {
    var options: IDropdownOption[] = [];

    withEmptyChoice &&
        options.push({
            key: 'null',
            text: '-'
        });
    if (locations) locations.map(y => options.push({ key: y.id, text: y.name ?? '' }));

    return options;
};

export { mapLocationsToOptions };
